import React from 'react';
import { useSelector } from 'react-redux';
import { Refresh, Store } from '@mui/icons-material';
import MobileConfirmation from '../MoobileConfirmaion';
import { useJunoCommonFunctions } from '../../../../client/Juno/helpers';
import { formatCurrency as _formatCurrency } from '../../../helpers/constant';


const TransferConfirmation = ({ formData, selectedMerchant, receiverDetails }) => {
    const { clientData } = useSelector(state => state.juno);
    const { image_base_url: imageBaseUrl } = useSelector(state => state.config);
    const { useWindowWidth } = useJunoCommonFunctions();

    const windowWidth = useWindowWidth();

    // Format currency for display
    const formatCurrency = amount => {
        return Number(amount).toFixed(2).toLocaleString();
    };

    const formattedAmount = formatCurrency(formData.amount || 0);
    const formattedBalance = formatCurrency(formData.currency?.balanceAmount || 0);

    const {
        amount = 0,
        email = '',
        reference = null,
        currency: { currencyShortName = 'USD', balanceAmount = 0, currencyIcon },
    } = formData;

    const data = {
        title: 'Transfer',
        amount: _formatCurrency(amount, currencyShortName),
        balance: _formatCurrency(balanceAmount, currencyShortName),
        currencyIcon,
        details: [
            {
                label: 'JUNO MONEY ACCOUNT NAME',
                value: receiverDetails?.username || null,
            },
            {
                label: 'EMAIL ADDRESS',
                value: email || null,
            },
            {
                isMerchant: true,
                label: 'Sending to',
                value: selectedMerchant?.merchantName || null,
                icon: selectedMerchant?.merchantIcon || null,
            },
            {
                label: 'REFERENCE',
                value: reference || null,
            },
        ].filter(x => x.value),
    };

    if (windowWidth <= 640) return <MobileConfirmation data={data} component = {'transfer'} />;

    return (
        <div className="flex flex-col gap-6">
            <div className="">
                <p className="text-xs font-medium text-balanceCard-manage uppercase mb-2">
                    Currency
                </p>
                <div className=" border  !border-input-border bg-card-bg rounded-md p-3">
                    <div className="flex justify-between items-center">
                        <div className="flex items-center gap-2">
                            {formData.currency?.currencyIcon && (
                                <img
                                    src={`${imageBaseUrl}${formData.currency.currencyIcon}`}
                                    width={24}
                                    height={24}
                                    alt="currencyIcon"
                                />
                            )}
                            <span className="text-base font-medium !text-text">
                                {formData.currency?.currencyShortName}
                            </span>
                        </div>
                        <p className="text-xl font-medium !text-text">
                            {formData.currency?.currencySymbol} {formattedAmount} (
                            {formData.currency?.currencyShortName})
                        </p>
                    </div>
                    <hr className=" !border-input-border h-[1px] my-2" />
                    <div className="flex justify-between items-center">
                        <p className="text-xs font-medium text-balanceCard-manage">Balance:</p>
                        <p className="text-xs font-normal text-balanceCard-manage">
                            {formData.currency?.currencySymbol} {formattedBalance} (
                            {formData.currency?.currencyShortName})
                        </p>
                    </div>
                </div>
            </div>

            {selectedMerchant && Object.keys(selectedMerchant).length > 0 ? (
                <div className="border  !border-input-border bg-card-bg rounded-md p-3 !text-text">
                    <div className="flex items-center gap-2">
                        {selectedMerchant.merchantLogo ? (
                            <img
                                src={selectedMerchant.merchantLogo}
                                alt={`${selectedMerchant.merchantName} Logo`}
                                className="rounded-full w-8 h-8"
                            />
                        ) : (
                            <div className="w-8 h-8 bg-input-border rounded-full flex justify-center items-center cursor-pointer">
                                <Store fontSize="medium" className="!text-primary" />
                            </div>
                        )}
                        <h1 className="!text-primary uppercase text-sm font-medium">
                            {selectedMerchant.merchantName}
                        </h1>
                    </div>
                </div>
            ) : (
                <div className="">
                    <p className="text-xs font-medium text-balanceCard-manage uppercase mb-2">
                        Transfer Details
                    </p>
                    <div className="border  !border-input-border bg-card-bg rounded-md p-3">
                        <div className="flex justify-between items-center">
                            <p className="text-xs font-medium text-balanceCard-manage uppercase">
                                JUNO MONEY ACCOUNT NAME:
                            </p>
                            <p className="text-xs font-semibold text-balanceCard-manage uppercase">
                                {receiverDetails?.username || ''}
                            </p>
                        </div>
                        <hr className=" !border-input-border h-[1px] my-2" />
                        <div className="flex justify-between items-center">
                            <p className="text-xs font-medium text-balanceCard-manage uppercase">
                                EMAIL ADDRESS:
                            </p>
                            <p className="text-xs font-semibold text-balanceCard-manage break-all text-right">
                                {formData.email || ''}
                            </p>
                        </div>
                    </div>
                </div>
            )}

            {formData.reference && (
                <div className="">
                    <p className="text-xs font-medium text-balanceCard-manage uppercase mb-2">
                        Reference
                    </p>
                    <div className="border  !border-input-border bg-card-bg rounded-md p-3">
                        <p className="text-xs font-medium text-balanceCard-manage uppercase break-words">
                            {formData.reference}
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default TransferConfirmation;
